import { ForwardedRef, useMemo, useRef } from "react";
import { mergeRefs } from "utils/merge-refs";

// A ref for tracking an element, merged with the ref forwarded from the parent
export const useTrackingRef = (forwardedRef: ForwardedRef<HTMLElement>) => {
    const ref = useRef<HTMLElement>(null);
    const mergedRef = useMemo(() => mergeRefs(ref, forwardedRef), [forwardedRef]);
    return [ref, mergedRef] as const;
};
